import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { MenuProvider } from "./contexts/menu.context";
import { BrowserRouter } from "react-router-dom";
import { RestOrderProvider } from "./contexts/restaurantOrder.context";
import { OrderTypeProvider } from "./contexts/orderType.context";
import { AccountsProvider } from "./contexts/accounts.context";
import { OrdersProvider } from "./contexts/orders.context";
import { InventoryProvider } from "./contexts/inventory.context";
import { OrderOfferProvider } from "./contexts/orderOffers.context";
import { LoyaltyProvider } from "./contexts/loyalty.context";
import { UserProvider } from "./contexts/users.context";
import { CustomerMenuProvider } from "./contexts/customerMenu.context";
import { CustomerOrderProvider } from "./contexts/customerOrder.context";
import { AffiliateProvider } from "./contexts/affiliate.context";
import { LoaderContext, LoaderProvider } from "./contexts/loader.context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LoaderProvider>
        <UserProvider>
          <AffiliateProvider>
            <MenuProvider>
              <OrdersProvider>
                <OrderTypeProvider>
                  <RestOrderProvider>
                    <AccountsProvider>
                      <InventoryProvider>
                        <OrderOfferProvider>
                          <LoyaltyProvider>
                            <CustomerMenuProvider>
                              <CustomerOrderProvider>
                                <App />
                              </CustomerOrderProvider>
                            </CustomerMenuProvider>
                          </LoyaltyProvider>
                        </OrderOfferProvider>
                      </InventoryProvider>
                    </AccountsProvider>
                  </RestOrderProvider>
                </OrderTypeProvider>
              </OrdersProvider>
            </MenuProvider>
          </AffiliateProvider>
        </UserProvider>
      </LoaderProvider>
    </BrowserRouter>
  </React.StrictMode>
);
